import request from '@/service/apiConfig/request'
/**
 * @description 个人信息
 */
export const getUserInfo = () => {
  // console.log('getUserInfo')
  return request.get('/investment/getUserInfo.htm');
};